import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtOI(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  return a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
}

function StatBox(props) {
  return (
    <div style={{ flex: 1, minWidth: 92, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '8px 12px', textAlign: 'center' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>{props.label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: props.color || '#e5e7eb', marginTop: 2 }}>{props.value}</div>
    </div>
  );
}

var FIELD_LBL = { fontSize: 12, color: '#8b98a9', marginBottom: 5 };
var FIELD_IN = { width: '100%', boxSizing: 'border-box', background: '#0d1524', border: '1px solid #26334a', borderRadius: 8, color: '#e5e7eb', fontSize: 14, padding: '9px 12px', fontFamily: 'inherit' };

function Field(props) {
  return (
    <div>
      <div style={FIELD_LBL}>{props.label}{props.hint ? <span style={{ color: '#ef4444', fontSize: 10 }}> {props.hint}</span> : null}</div>
      {props.options ? (
        <select value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN}>
          {props.options.map(function (o) { return <option key={o[0]} value={o[0]}>{o[1]}</option>; })}
        </select>
      ) : (
        <input type={props.type || 'text'} value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN} />
      )}
    </div>
  );
}

function WallBox(props) {
  var w = props.wall;
  var held = props.heldStrike != null && w && w.strike === props.heldStrike;
  return (
    <div style={{ flex: 1, minWidth: 150, background: '#0d1524', border: '1px solid ' + (held ? 'rgba(34,197,94,0.5)' : '#1f2937'), borderRadius: 10, padding: '10px 14px' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: props.color }}>{props.label}</div>
      {w ? (
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#e5e7eb', marginTop: 2 }}>
            {w.strike}
            {held ? <span style={{ fontSize: 9, fontWeight: 800, color: '#22c55e', marginLeft: 8 }}>HELD ✓</span> : null}
          </div>
          <div style={{ fontSize: 11, color: props.color, fontWeight: 800 }}>{fmtOI(w.oi)} OI</div>
        </div>
      ) : <div style={{ fontSize: 11, color: '#6b7a8d', padding: '8px 0' }}>--</div>}
    </div>
  );
}

var OIWallsLive = function () {
  var [state, setState] = useState(null);
  var [showCfg, setShowCfg] = useState(false);
  var [draft, setDraft] = useState({});
  var [err, setErr] = useState('');
  var [confirm, setConfirm] = useState('');   // 'enable' | 'enter' | 'exit'
  var [busy, setBusy] = useState(false);

  var fetchState = useCallback(function () {
    fetch(API + '/oiwalls-live/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setState(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var cfg = (state && state.config) || {};
  var enabled = !!(state && state.enabled);
  var dryRun = !!(state && state.dry_run);

  function post(path, body, after) {
    setBusy(true);
    fetch(API + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function () {
      setBusy(false); setConfirm('');
      if (after) after();
      setTimeout(fetchState, 500);
    }).catch(function () { setBusy(false); });
  }

  function openCfg() {
    setDraft({
      dry_run: cfg.dry_run ? 1 : 0,
      lots: cfg.lots != null ? cfg.lots : 1,
      product: cfg.product || 'MIS',
      hedge_entry_time: cfg.hedge_entry_time || '09:16',
      entry_time: cfg.entry_time || '09:17',
      exit_time: cfg.exit_time || '15:00',
      check_interval_sec: cfg.check_interval_sec != null ? cfg.check_interval_sec : 30,
      band: cfg.band != null ? cfg.band : 5,
      band_expiry: cfg.band_expiry != null ? cfg.band_expiry : 3,
      zone_mode: cfg.zone_mode || 'own_side',
      roll_threshold_pct: cfg.roll_threshold_pct != null ? cfg.roll_threshold_pct : 5,
      max_rolls_per_side: cfg.max_rolls_per_side != null ? cfg.max_rolls_per_side : 0,
      min_sell_premium: cfg.min_sell_premium != null ? cfg.min_sell_premium : 5,
      hedge_enabled: cfg.hedge_enabled ? 1 : 0,
      hedge_target_price: cfg.hedge_target_price != null ? cfg.hedge_target_price : 5,
      hedge_max_price_gap: cfg.hedge_max_price_gap != null ? cfg.hedge_max_price_gap : 0,
      hedge_exit_mode: cfg.hedge_exit_mode || 'final_only',
      weekdays: Object.assign(
        { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true },
        (cfg.weekdays && typeof cfg.weekdays === 'object') ? cfg.weekdays : {}),
      mtm_sl_per_lot: cfg.mtm_sl_per_lot || 0,
      target_per_lot: cfg.target_per_lot || 0,
      protect_per_lot: cfg.protect_per_lot || 0,
      protect_level_per_lot: cfg.protect_level_per_lot || 0,
      trail_step_per_lot: cfg.trail_step_per_lot || 0,
    });
    setShowCfg(true);
  }

  function saveCfg() {
    var strKeys = { hedge_entry_time: 1, entry_time: 1, exit_time: 1, zone_mode: 1, hedge_exit_mode: 1, product: 1 };
    var boolKeys = { dry_run: 1, hedge_enabled: 1 };
    var p = {};
    Object.keys(draft).forEach(function (k) {
      var v = draft[k];
      // weekdays is an OBJECT — the default branch runs Number(v), which would
      // turn it into NaN and silently wipe the schedule.
      if (k === 'weekdays') { p[k] = v; return; }
      p[k] = strKeys[k] ? v : boolKeys[k] ? Number(v) === 1 : Number(v);
    });
    post('/oiwalls-live/config', p, function () { setShowCfg(false); });
  }
  function D(k) { return function (v) { var d = Object.assign({}, draft); d[k] = v; setDraft(d); }; }

  var walls = (state && state.walls) || {};
  var legs = (state && state.legs) || [];
  var st = (state && state.stats) || {};
  var events = (state && state.events) || [];
  var cardBase = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px' };
  var openLegs = legs.filter(function (l) { return l.status === 'open'; });
  var sellLegs = legs.filter(function (l) { return l.role === 'sell'; });
  var heldCE = (sellLegs.filter(function (l) { return l.type === 'CE' && l.status === 'open'; })[0] || {}).strike;
  var heldPE = (sellLegs.filter(function (l) { return l.type === 'PE' && l.status === 'open'; })[0] || {}).strike;

  var statusText = state && state.disabled_for_day ? 'CIRCUIT BREAKER — disabled for the day'
    : state && state.weekday_ok === false
      ? (state.weekday_today || 'Today') + ' is unticked in Trading Days — no entry today'
    : state && state.day_stopped && state.hedges_open ? 'Sells closed (' + state.day_stopped + ') — hedges held to ' + (cfg.exit_time || '15:00')
    : state && state.day_stopped ? 'Day stopped (' + state.day_stopped + ')'
    : state && state.entered_today && !state.active ? 'Done for the day — one entry per day'
    : state && state.active ? 'In position'
    : enabled ? 'Armed — enters at ' + (cfg.entry_time || '09:17')
    : 'Disabled';

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1300 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 22, fontWeight: 800 }}>🧱 OI Walls LIVE</span>
                        {dryRun ? (
              <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '3px 8px' }}>DRY RUN — NO ORDERS SENT</span>
            ) : null}
            {state && state.is_expiry_day ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.45)', borderRadius: 6, padding: '3px 8px' }}>EXPIRY · band ±{cfg.band_expiry || 3}</span> : null}
            {state && state.hedges_open && !state.active && !state.entered_today ? <span style={{ fontSize: 9, fontWeight: 800, color: '#22c55e', background: 'rgba(34,197,94,0.12)', border: '1px solid rgba(34,197,94,0.5)', borderRadius: 6, padding: '3px 8px' }}>HEDGES IN ✓ — awaiting sells</span> : null}
            {state && state.hedges_open && !state.active && state.entered_today ? <span style={{ fontSize: 9, fontWeight: 800, color: '#a78bfa', background: 'rgba(167,139,250,0.12)', border: '1px solid rgba(167,139,250,0.5)', borderRadius: 6, padding: '3px 8px' }}>HEDGES HELD</span> : null}
            {state && state.disabled_for_day ? <span style={{ fontSize: 9, fontWeight: 800, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.45)', borderRadius: 6, padding: '3px 8px' }}>CIRCUIT BREAKER</span> : null}
            {state && state.weekday_ok === false ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '3px 8px' }}>{(state.weekday_today || 'TODAY').toUpperCase()} OFF</span> : null}
            {state && (state.net_zero_sides || []).length ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '3px 8px' }}>NET ZERO · {(state.net_zero_sides || []).join(' + ')}</span> : null}
          </div>
          <div style={{ fontSize: 10, color: '#6b7a8d', marginTop: 3 }}>
            NIFTY · {cfg.lots || 1}L · {cfg.product || 'MIS'} · Hedges {cfg.hedge_entry_time || '09:16'} · Sells {cfg.entry_time || '09:17'} · sells the walls (max Total OI, ATM±{cfg.band || 5}) · rolls on &gt;{cfg.roll_threshold_pct || 5}% leadership · exit {cfg.exit_time || '15:00'}
          </div>
          <div style={{ fontSize: 10, color: '#8b98a9', marginTop: 2 }}>{statusText}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: enabled ? '#22c55e' : '#6b7a8d' }}>
            {enabled ? '● ENABLED' : '○ DISABLED'}
          </span>
          {enabled ? (
            <button onClick={function () { post('/oiwalls-live/disable'); }} disabled={busy}
              style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '7px 18px', background: 'rgba(239,68,68,0.12)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.5)' }}>
              Disable
            </button>
          ) : (
            <button onClick={function () { post('/oiwalls-live/enable'); }} disabled={busy}
              style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '7px 18px', background: 'rgba(34,197,94,0.12)', color: '#22c55e', border: '1px solid rgba(34,197,94,0.5)' }}>
              Enable
            </button>
          )}
          <button onClick={openCfg}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#8b98a9', border: '1px solid #1f2937', borderRadius: 8, padding: '7px 14px', fontFamily: 'inherit' }}>⚙</button>
        </div>
      </div>

      {err ? <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>OI Walls LIVE: {err}</div> : null}

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1.1, minWidth: 330, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>
              WALLS · ATM {walls.atm || '--'} · ±{walls.band || (state && state.is_expiry_day ? cfg.band_expiry : cfg.band) || '--'} · {(walls.zone || cfg.zone_mode) === 'any' ? 'ANY STRIKE' : 'OWN SIDE'}
            </span>
            <span style={{ fontSize: 10, color: '#6b7a8d' }}>{walls.time || '--'}</span>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <WallBox label="CE WALL (resistance)" wall={walls.ce} color="#ef4444" heldStrike={heldCE} />
            <WallBox label="PE WALL (support)" wall={walls.pe} color="#22c55e" heldStrike={heldPE} />
          </div>
          <div style={{ fontSize: 9, color: '#556677', marginTop: 8 }}>
            Spot {state && state.spot ? state.spot.toFixed(1) : '--'} · expiry {(state && state.expiry_label) || '--'}
            {cfg.hedge_enabled ? ' · hedges ON, nearest ₹' + cfg.hedge_target_price + ', exit ' + (cfg.hedge_exit_mode === 'with_sells' ? 'with sells' : 'final only') : ' · NAKED (no hedges)'}
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 320, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>
              POSITION{legs.length ? ' · ' + openLegs.length + '/' + legs.length + ' open' : ''}
            </span>
            {legs.length ? <span style={{ fontSize: 11, fontWeight: 800, color: (st.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(st.day_pnl)}</span> : null}
          </div>
          {legs.length ? (
            <div style={{ fontSize: 11, lineHeight: 1.85 }}>
              <div style={{ fontWeight: 800, color: '#38bdf8', marginBottom: 3 }}>
                net premium {state && state.entry_premium != null ? state.entry_premium : '--'} · {cfg.lots || 1}L
              </div>
              {legs.map(function (l, i) {
                var closed = l.status === 'closed';
                return (
                  <div key={i} style={{ color: closed ? '#556677' : '#8b98a9', textDecoration: closed ? 'line-through' : 'none' }}>
                    <span style={{ fontWeight: 800, color: l.role === 'hedge' ? '#a78bfa' : (l.side === 'SELL' ? '#ef4444' : '#22c55e') }}>
                      {l.role === 'hedge' ? 'HEDGE' : 'SELL'}
                    </span>{' '}
                    {!closed && (state.net_zero_sides || []).indexOf(l.type) >= 0 ? <span style={{ fontSize: 8, fontWeight: 800, color: '#fbbf24' }}>[NET0] </span> : null}
                    {l.strike} {l.type} @ {l.entry_price} → {closed ? l.exit_price : l.ltp}
                    {l.oi_at_entry ? <span style={{ fontSize: 9, color: '#556677', marginLeft: 6 }}>OI@in {fmtOI(l.oi_at_entry)}</span> : null}
                    <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ fontSize: 10, color: '#6b7a8d', padding: '14px 0', textAlign: 'center' }}>
              No legs today. {enabled ? 'Enters at ' + (cfg.entry_time || '09:17') + '.' : 'Strategy is disabled.'}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <StatBox label="DAY P&L" value={fmtINR(st.day_pnl)} color={(st.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="REALIZED" value={fmtINR(st.realized)} color={(st.realized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="UNREALIZED" value={fmtINR(st.unrealized)} color={(st.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="SELL LEGS" value={fmtINR(st.sell_unrealized)} color={(st.sell_unrealized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="ROLLS CE" value={st.rolls_ce != null ? st.rolls_ce : '--'} color="#ef4444" />
        <StatBox label="ROLLS PE" value={st.rolls_pe != null ? st.rolls_pe : '--'} color="#22c55e" />
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        {confirm === 'enter' ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.35)', borderRadius: 8, padding: '6px 10px' }}>
            <span style={{ fontSize: 11, color: '#ef4444', fontWeight: 800 }}>Force entry now{dryRun ? ' (dry run)' : ''}?</span>
            <button onClick={function () { post('/oiwalls-live/enter'); }} disabled={busy}
              style={{ fontSize: 10, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 6, padding: '5px 14px', background: '#ef4444', color: '#fff', border: 'none' }}>YES, ENTER</button>
            <button onClick={function () { setConfirm(''); }}
              style={{ fontSize: 10, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 6, padding: '5px 12px', background: 'transparent', color: '#8b98a9', border: '1px solid #26334a' }}>Cancel</button>
          </span>
        ) : (
          <button onClick={function () { setConfirm('enter'); }} disabled={busy || (state && state.active)}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '8px 18px', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a', opacity: (state && state.active) ? 0.4 : 1 }}>
            Force Enter
          </button>
        )}
        {confirm === 'exit' ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.35)', borderRadius: 8, padding: '6px 10px' }}>
            <span style={{ fontSize: 11, color: '#ef4444', fontWeight: 800 }}>Exit all legs now?</span>
            <button onClick={function () { post('/oiwalls-live/exit'); }} disabled={busy}
              style={{ fontSize: 10, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 6, padding: '5px 14px', background: '#ef4444', color: '#fff', border: 'none' }}>YES, EXIT</button>
            <button onClick={function () { setConfirm(''); }}
              style={{ fontSize: 10, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 6, padding: '5px 12px', background: 'transparent', color: '#8b98a9', border: '1px solid #26334a' }}>Cancel</button>
          </span>
        ) : (
          <button onClick={function () { setConfirm('exit'); }} disabled={busy || !openLegs.length}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '8px 18px', background: 'rgba(239,68,68,0.12)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.5)', opacity: openLegs.length ? 1 : 0.4 }}>
            Exit Now
          </button>
        )}
        <span style={{ fontSize: 10, color: '#556677' }}>
          {dryRun ? 'Dry run active — buttons run the full decision path but submit no orders.' : ''}
        </span>
      </div>

      <div style={{ ...cardBase }}>
        <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 10 }}>ACTIVITY LOG</div>
        <div style={{ maxHeight: 340, overflowY: 'auto' }}>
          {events.length ? events.slice().reverse().map(function (ev, i) {
            var col = ev.level === 'error' ? '#ef4444' : ev.level === 'warning' ? '#fbbf24' : ev.level === 'success' ? '#22c55e' : '#8b98a9';
            return <div key={i} style={{ fontSize: 10, color: col, padding: '3px 0', borderBottom: '1px solid #0d1524' }}>
              <span style={{ color: '#556677' }}>{ev.time}</span> {ev.text}
            </div>;
          }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '14px 0' }}>Quiet.</div>}
        </div>
      </div>

      {showCfg ? (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(3,6,12,0.75)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}
          onClick={function (e) { if (e.target === e.currentTarget) setShowCfg(false); }}>
          <div style={{ background: '#0b1220', border: '1px solid #26334a', borderRadius: 14, padding: '22px 26px', width: '100%', maxWidth: 580 }}>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>OI Walls LIVE Settings</div>
            <div style={{ fontSize: 10, color: '#6b7a8d', marginBottom: 18 }}>Real-money strategy. Wall selection and rolling are identical to the paper engine.</div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#ef4444', margin: '0 0 10px' }}>SAFETY</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Order Mode" value={draft.dry_run} onChange={D('dry_run')}
                options={[[1, 'DRY RUN — log only, no orders'], [0, 'LIVE — send real orders']]} />
              <Field label="Product" value={draft.product} onChange={D('product')}
                options={[['MIS', 'MIS (intraday, auto-square ~15:20)'], ['NRML', 'NRML (carry)']]} />
              <Field label="Lots" type="number" value={draft.lots} onChange={D('lots')} />
              <Field label="Min Sell Premium ₹" type="number" value={draft.min_sell_premium} onChange={D('min_sell_premium')} />
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>SCHEDULE</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Entry Time" value={draft.entry_time} onChange={D('entry_time')} />
              <Field label="Exit Time" value={draft.exit_time} onChange={D('exit_time')} />
              <Field label="Check Interval (s)" type="number" value={draft.check_interval_sec} onChange={D('check_interval_sec')} />
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#a78bfa', margin: '20px 0 10px' }}>HEDGES</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Hedges" value={draft.hedge_enabled} onChange={D('hedge_enabled')}
                options={[[1, 'ON — buy wings first'], [0, 'OFF — naked strangle']]} />
              <Field label="Hedge Deploy Time" value={draft.hedge_entry_time} onChange={D('hedge_entry_time')} />
              <Field label="Hedge Close To Price ₹" type="number" value={draft.hedge_target_price} onChange={D('hedge_target_price')} />
              <Field label="Max Price Gap ₹" hint="(0=accept nearest)" type="number" value={draft.hedge_max_price_gap} onChange={D('hedge_max_price_gap')} />
              <Field label="Hedge Exit" value={draft.hedge_exit_mode} onChange={D('hedge_exit_mode')}
                options={[['final_only', 'Final exit only (hold past SL)'], ['with_sells', 'With the sells (AMB2 style)']]} />
            </div>
            <div style={{ fontSize: 10, color: '#6b7a8d', marginTop: 8 }}>
              Wings are chosen purely by premium (nearest the target, OTM from ATM) and deploy at their own time, independent of the sell legs. If either fails to fill, no sell goes out at all.
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>TRADING DAYS <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(unticked days are skipped entirely \u2014 no hedges, no sells)</span></div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
              {[['monday','Mon'],['tuesday','Tue'],['wednesday','Wed'],['thursday','Thu'],['friday','Fri']].map(function (d) {
                var key = d[0], label = d[1];
                var on = (draft.weekdays || {})[key] !== false;
                return (
                  <label key={key} style={{
                    display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer',
                    background: on ? 'rgba(34,197,94,0.10)' : '#0d1524',
                    border: '1px solid ' + (on ? 'rgba(34,197,94,0.45)' : '#26334a'),
                    borderRadius: 6, padding: '6px 11px',
                  }}>
                    <input type="checkbox" checked={on}
                      onChange={function (e) {
                        var w = Object.assign({}, draft.weekdays || {});
                        w[key] = e.target.checked;
                        D('weekdays')(w);
                      }} />
                    <span style={{ fontSize: 11, fontWeight: 800, color: on ? '#22c55e' : '#556677' }}>{label}</span>
                  </label>
                );
              })}
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>WALL SELECTION <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(same logic as paper)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Candidate Band" value={draft.band} onChange={D('band')}
                options={[[5, 'ATM ±5 strikes'], [10, 'ATM ±10 strikes']]} />
              <Field label="Expiry-Day Band" value={draft.band_expiry} onChange={D('band_expiry')}
                options={[[2, 'ATM ±2 strikes'], [3, 'ATM ±3 strikes'], [4, 'ATM ±4 strikes'], [5, 'ATM ±5 strikes']]} />
              <Field label="Candidate Zone" value={draft.zone_mode} onChange={D('zone_mode')}
                options={[['own_side', 'Own side (CE ≥ ATM · PE ≤ ATM)'], ['any', 'Any strike in band']]} />
              <Field label="Roll Threshold %" type="number" value={draft.roll_threshold_pct} onChange={D('roll_threshold_pct')} />
              <Field label="Max Rolls / side" hint="(0=unlimited, paper parity)" type="number" value={draft.max_rolls_per_side} onChange={D('max_rolls_per_side')} />
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>PROFIT MANAGEMENT <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(₹ per lot · any trigger exits &amp; stops the day)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="MTM SL ₹/lot" hint="(0=off)" type="number" value={draft.mtm_sl_per_lot} onChange={D('mtm_sl_per_lot')} />
              <Field label="Target ₹/lot" hint="(0=off)" type="number" value={draft.target_per_lot} onChange={D('target_per_lot')} />
              <Field label="Protect ₹/lot" hint="(0=off)" type="number" value={draft.protect_per_lot} onChange={D('protect_per_lot')} />
              <Field label="Protect Level ₹/lot" type="number" value={draft.protect_level_per_lot} onChange={D('protect_level_per_lot')} />
              <Field label="Trail Step ₹/lot" hint="(0=off)" type="number" value={draft.trail_step_per_lot} onChange={D('trail_step_per_lot')} />
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button onClick={function () { setShowCfg(false); }}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a', borderRadius: 10, padding: '12px 0' }}>Cancel</button>
              <button onClick={saveCfg} disabled={busy}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: 'rgba(34,197,94,0.15)', color: '#22c55e', border: '1px solid rgba(34,197,94,0.5)', borderRadius: 10, padding: '12px 0' }}>Save</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OIWallsLive;
